import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as Constants from "../../../shared/Constants";
import * as actions from '../../../store/actions/index';
import PortalForm from '../../PortalForm/PortalForm';
import Spinner from '../../../UI/Spinner/Spinner';
import DisplayBox from '../../../hoc/DisplayBox/DisplayBox';
// import Message from '../../../components/Message/Message';
import Modal from '../../../UI/Modal/Modal';
import ModifyEligConfirm from '../../../components/ModifyEligibilityConfirmation/ModifyEligbilityConfirmation';

class ModifyEligibility extends Component {

    state = {
        formData: null,
        memberPortalId: null
    }

    componentDidMount () {
        //console.log("[Modify Eligibility] componentDidMount", this.props.portalsList, this.props.selectedPortal, this.props.modifyEligPortal);
        if(!this.props.portalsList || !this.props.portalsList.length > 0) {
            this.props.fetchPortals();
        }
        if(!this.props.statesList || !this.props.statesList.length > 0) {
            this.props.fetchStates();
        }
        window.scrollTo(0, 0);
    }

    toggleModalHandler = (formData) => {
        //console.log("[Member Eligibility] toggleModalHandler formData", formData);
        if(formData.targetPortal === "CAP") {
            this.props.fetchFaroId(formData);
        } else {
            this.props.toggleModifyEligModal();
        }
        this.setState({formData: formData});
    }

    modifyEligibilityHandler = (formData, memberPortalId) => {
        formData = {
            ...formData,
            targetPortal : this.props.selectedPortal.parentPortalId && this.props.selectedPortal.portalBrandName ? this.props.selectedPortal.portalBrandName : formData.targetPortal,
            healthSafeId: this.props.member.healthSafeId,
            requestType: "PORTAL",
            memberPortalId: memberPortalId
        }

        this.props.addEligibility(formData);
    }

    //TTODO: update
    resetFormData = (portalForm, ignoreFields) => {
        // console.log("[AddAccount] clearFormData", targetPortal);
        return this.setEligibilityData(portalForm, this.props.selectedPortal);
    }

    setEligibilityData = (form, selectedPortal) => {

        delete form["UUID"];

        // let memberData = this.props.member.memberPortalAttributeList.find(x => {
        //     // console.log("[Modify Eligibility] setEligibilityData portal list x =", x);
        //     if (x.portalShortNm === this.props.modifyEligPortal.portalShortNm && (!x.portalPolicyNbr || x.portalPolicyNbr === this.props.modifyEligPortal.portalPolicyNbr)) {
        //         return x;
        //     } else {
        //         return memberData;
        //     }
        // });

        let memberData = this.props.modifyEligPortal;

        for(let key in form) {
            switch (key) {
                case "targetPortal":
                    form["targetPortal"].value = selectedPortal.portalId;
                    form["targetPortal"].disabled = true;
                    break;
                case "FirstName":
                    form["FirstName"].value = memberData.portalFirstNm;
                    break;
                case "LastName":
                    form["LastName"].value = memberData.portalLastNm;
                    break;
                case "DOB":
                    form["DOB"].value = memberData.portalDob;
                    break;
                case "Gender":
                    form["Gender"].value = memberData.portalGender;
                    break;
                case "Address_1":
                    form["Address_1"].value = memberData.portalAddressLine1;
                    break;
                case "Address_2":
                    form["Address_2"].value = memberData.portalAddressLine1;
                    break;
                case "City":
                    form["City"].value = memberData.portalCity;
                    break;
                case "State":
                    form["State"].value = memberData.portalState;
                    break;
                case "ZipCode":
                    form["ZipCode"].value = memberData.portalZip;
                    break;
                case "SSN":
                    form["SSN"].value = selectedPortal.portalShortName === 'YTTH' || selectedPortal.portalId === 1?'':memberData.portalSsn;
                    // form["SSN"].disabled = selectedPortal.portalId === 1 && memberData.portalSubscriberId ? true : false;
                    break;
                case "GroupId":
                    form["GroupId"].value = memberData.portalPolicyNbr;
                    break;
                case "SubscriberId":
                    form["SubscriberId"].value = selectedPortal.portalId === 1?'':memberData.portalSubscriberId;
                    // form["SubscriberId"].disabled = selectedPortal.portalId === 1 && memberData.portalSSN ? true : false;
                    break;
                case "MemberId":
                    form["MemberId"].value = selectedPortal.portalShortName === 'MYUHC'? memberData.portalSubscriberId : memberData.portalSpecificMemberId;
                    break;
                default:
                    break;
            }
        }

        // console.log("[Modify Eligibility] setEligibilityData final form", memberData, form);

        // this.setState({memberPortalData: memberData});

        return form;
    }

    render() {

        // console.log("[Modify Eligibility] render", this.props.portalsLoading, this.props.portalInfoLoading, this.props.modifyEligPortal, this.props.portalsList, this.props.portalsInfo, this.props.showModifyEligModal);

        // let modal = <Modal show={this.state.showModifyEligModal} modalClosed={this.toggleModalHandler}><ModifyEligConfirm/></Modal>

        let form = <Spinner/>;
        if(!this.props.member) {
            form = (
                <DisplayBox>
                    {/* <Link to="/search"><Message msgType="Invalid" info={{message:'Please select a member >>'}} /></Link> */}
                    <Redirect to="/search"></Redirect>
                </DisplayBox>
            );
        } else if(this.props.member && !this.props.portalsLoading && !this.props.portalInfoLoading && this.props.modifyEligPortal) {

            // const memberPortalList = this.props.member.memberPortalAttributeList;
            // const portal = memberPortalList.find(x => x.portalShortName = this.props.modifyEligPortal.portalShortNm);
            //console.log("[Modify Eligibility] render modifyEligPortal", this.props.modifyEligPortal, this.props.portalsInfo, this.props.showModifyEligModal);

            // form = <div>"Build Modify Elig Form"</div>
            form = (
                <PortalForm
                    formHeader = {Constants.MODIFY_ELIGIBILITY}
                    formMessage = {Constants.MODIFY_ELIGIBILITY_ALL_FIELDS_REQUIRED}
                    message = {this.props.message}
                    selectedPortal = {this.props.selectedPortal}
                    portalsList = {this.props.portalsList}
                    portalsInfo = {this.props.portalsInfo}
                    portalInfoLoading = {this.props.portalInfoLoading}
                    submitButtonLabel = {Constants.LABEL_UPDATE}
                    modifyEligPortal = {this.props.modifyEligPortal}

                    submitFormHandler = {this.toggleModalHandler}
                    resetFormHandler = {this.resetFormData}
                    portalSelectHandler = {this.props.setModifyEligibilitySelectedPortal}
                    displayMessageHandler = {this.props.setDisplayMessage}
                    addFunctionSpecificData = {this.setEligibilityData}
                    memberInfo={this.props.member}
                />
            );
        }

        let confirmModal = this.props.showModifyEligModal?(
            <Modal show={this.props.showModifyEligModal && this.state.formData} modalClosed={this.toggleModalHandler}>
                <ModifyEligConfirm
                    modifyEligPortal = {this.props.modifyEligPortal}
                    updatedFormData={this.state.formData}
                    memberInfo={this.props.member}
                    selectedPortal={this.props.selectedPortal}
                    updateEligibility={this.modifyEligibilityHandler}
                    cancelled={this.toggleModalHandler}
                    faroId = {this.props.memberFaroID}
                />
            </Modal>
        ): null;
        // console.log("[AddAccount] render", this.props);
        return (
            <Fragment>
                {confirmModal}
                {form}
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedPortal: state.addEligibility.modifyEligSelectedPortal,
        message: state.addEligibility.modifyEligMessage,
        portalsList: state.addEligibility.portals,
        portalsInfo: state.addEligibility.portalsInfo,
        portalsLoading: state.addEligibility.portalsLoading,
        portalInfoLoading: state.addEligibility.portalInfoLoading,
        member: state.member.member,
        eligibilityUpdated: state.addEligibility.eligibilityUpdated,
        modifyEligPortal: state.addEligibility.modifyEligPortal,
        showModifyEligModal: state.addEligibility.showModifyEligModal,
        memberFaroID: state.addEligibility.memberFaroID,
        statesList: state.refData.states
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        //TTODO: not needed: update
        addEligibility: (memberInfo, idType) => dispatch(actions.addEligibility(memberInfo, ownProps.history, "MODIFY", idType)),
        //TTODO: Not needed: update
        // addBankEligibility: (memberInfo) => dispatch(actions.addBankEligibility(memberInfo, ownProps.history)),
        //TTODO: Done: update
        setDisplayMessage: (message) => dispatch(actions.setModifyEligibilityMessage(message)),
        setModifyEligibilityPortal: (portalInfo) => dispatch(actions.setModifyEligibilityPortal(portalInfo)),
        fetchPortals: () => dispatch(actions.fetchEligibilityPortals()),
        setModifyEligibilitySelectedPortal: (portal) => dispatch(actions.setModifyEligibilitySelectedPortal(portal)),
        fetchFaroId: (formData) => dispatch(actions.fetchFaroId(formData, "MODIFY")),
        toggleModifyEligModal: () => dispatch(actions.toggleModifyEligModal()),
        fetchStates: () => dispatch(actions.fetchStates()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModifyEligibility);
